var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Storage } from "../../../../lib/localstorege.service";
import { Api } from "./account.transactions.api";
import { currencyFormat, dateTimeFormat, initialLeftMenu, sportsMenu, useForceUpdate } from "../../../../lib/misc.functions";
import { env, TransactionTypeLabel } from "../../../../definitions/global.vars";
import { modalServiceSubject } from "../../../../components/modal/modal";
import { useTranslation } from "react-i18next";
var page = 0;
var hasMore = true;
var AccountTransactions = function (props) {
    var _a = useState(-1), accountTransactionsStatus = _a[0], setAccountTransactionsStatus = _a[1];
    var _b = useTranslation(), t = _b.t, i18n = _b.i18n;
    useEffect(function () {
        initialLeftMenu(false);
    }, [sportsMenu.isVisible]);
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "my-profile-info-block" }, { children: [_jsx("div", __assign({ className: "overlay-header" }, { children: t('transactions.title') }), void 0), _jsx("div", __assign({ className: "u-i-e-p-p-content-bc u-i-common-content", "data-scroll-lock-scrollable": "" }, { children: _jsx(ListCoupons, { accountTransactionsStatus: accountTransactionsStatus, params: props.params }, void 0) }), void 0)] }), void 0) }, void 0));
};
export default AccountTransactions;
var accountTransactionData = [];
var lockScroll = false;
var accountTransactionStatus = -1;
var timer;
export function ListCoupons(props) {
    var forceUpdate = useForceUpdate();
    var params = props;
    useEffect(function () {
        window.scrollTo(0, 0);
        accountTransactionData = [];
        fetchData(true);
    }, [params.accountTransactionsStatus, props.params.subpage]);
    var _a = useTranslation(), t = _a.t, i18n = _a.i18n;
    // @ts-ignore
    accountTransactionStatus = params.accountTransactionsStatus;
    var fetchData = function (isFirst, forcePage, top) {
        if (isFirst === void 0) { isFirst = false; }
        if (forcePage === void 0) { forcePage = null; }
        if (top === void 0) { top = null; }
        try {
            // // @ts-ignore
            // document.getElementById('loadingAnimation').style.display = 'block';
            hasMore = false;
            if (isFirst) {
                accountTransactionData = [];
                page = forcePage !== null ? forcePage : 0;
                hasMore = true;
            }
            var data = {
                token: Storage.get('token'),
                page: page
            };
            if (Number(accountTransactionStatus) !== -1) {
                data['trans_type'] = accountTransactionStatus;
            }
            // @ts-ignore
            var objectHeight_1 = document.getElementById('InfiniteScroll').offsetHeight;
            // @ts-ignore
            var objectTop_1 = document.getElementById('InfiniteScroll').offsetTop;
            Api.start('post', env.list_api + '/accounting/api/transactions/', data, true).then(function (result) {
                // // @ts-ignore
                // document.getElementById('loadingAnimation').style.display = 'none';
                if (result.status) {
                    if (result.data.length < 20) {
                        hasMore = false;
                        lockScroll = true;
                    }
                    else {
                        hasMore = true;
                    }
                    page += 1;
                    accountTransactionData = accountTransactionData.concat(result.data);
                    forceUpdate();
                    if (!isFirst) {
                        if (top === 0) {
                            window.scrollTo(0, top);
                        }
                        else {
                            var threshold = window.outerHeight < 700 ? 600 : 700;
                            window.scrollTo(0, (objectHeight_1 - objectTop_1 - threshold));
                        }
                    }
                    timer = setTimeout(function () {
                        if (result.data.length >= 20) {
                            lockScroll = false;
                            if (accountTransactionData.length === 20 && objectHeight_1 < window.outerHeight) {
                                fetchData(false, 1, 0);
                            }
                        }
                        triggerScroll();
                    }, 500);
                }
                else {
                    modalServiceSubject.next({
                        title: 'beklenmedik bir sorun',
                        content: result.message,
                        confirm: {
                            cancel: { label: t('Ok') }
                        },
                        timeout: 3000,
                    });
                }
            });
        }
        catch (e) {
            console.error(e);
        }
    };
    useEffect(function () {
        window.addEventListener('scroll', triggerScroll);
        return function () {
            clearTimeout(timer);
            window.removeEventListener('scroll', triggerScroll);
        };
    }, []);
    var triggerScroll = function () {
        var threshold = window.outerHeight < 968 ? 100 : 150;
        // @ts-ignore
        var objectHeight = document.getElementById('InfiniteScroll').offsetHeight;
        // @ts-ignore
        var objectTop = document.getElementById('InfiniteScroll').offsetTop;
        var visibleZone = (window.outerHeight - objectTop - threshold);
        if (objectHeight > visibleZone) {
            if ((objectHeight - visibleZone) < window.scrollY && !lockScroll) {
                lockScroll = true;
                fetchData(false);
            }
        }
    };
    return (_jsx(_Fragment, { children: _jsxs("div", __assign({ className: "historyList-table-details", id: "InfiniteScroll" }, { children: [_jsx("div", __assign({ className: "historyList-thead" }, { children: _jsxs("div", __assign({ className: "historyListEl" }, { children: [_jsx("div", __assign({ className: "historyListEl-list-item " }, { children: _jsx("div", __assign({ className: "historyListEl-info" }, { children: t('transactions.header1') }), void 0) }), void 0), _jsx("div", __assign({ className: "historyListEl-list-item " }, { children: _jsx("div", __assign({ className: "historyListEl-info" }, { children: t('transactions.header2') }), void 0) }), void 0), _jsx("div", __assign({ className: "historyListEl-list-item " }, { children: _jsx("div", __assign({ className: "historyListEl-info" }, { children: t('transactions.header3') }), void 0) }), void 0)] }), void 0) }), void 0), _jsx("div", __assign({ className: "historyList-tbody" }, { children: accountTransactionData.map(function (data, key) {
                        return (_jsxs("div", __assign({ className: "historyListEl" }, { children: [_jsxs("div", __assign({ className: "historyListEl-list-item" }, { children: [_jsx("time", __assign({ className: "historyListEl-date" }, { children: dateTimeFormat(data.transaction_date) }), void 0), _jsxs("div", __assign({ className: "historyListEl-info" }, { children: ["K\u0130ML\u0130K:", data.id, _jsx("i", { title: "Copy id", className: "bc-booking-copy bc-i-copy" }, void 0)] }), void 0), _jsxs("div", __assign({ className: "historyListEl-info" }, { children: ["secondary_id:", data.description, _jsx("i", { title: "Copy id", className: "bc-booking-copy bc-i-copy" }, void 0)] }), void 0)] }), void 0), _jsx("div", __assign({ className: "historyListEl-list-item " }, { children: _jsx("div", __assign({ className: "historyListEl-info" }, { children: t(TransactionTypeLabel[data.trans_type]) }), void 0) }), void 0), _jsx("div", __assign({ className: "historyListEl-list-item " }, { children: _jsxs("div", __assign({ className: "historyListEl-info fw-bold", "data-status": Number(data.io_type) === 0 ? "3" : "2", "data-cur": "\u20BA" }, { children: [Number(data.io_type) === 0 ? '-' : '+', currencyFormat(Number(data.amount))] }), void 0) }), void 0)] }), "accountTransactions" + key));
                    }) }), void 0)] }), void 0) }, void 0));
}
